module.exports = __webpack_public_path__ + "img/feet.8d62214a.png";